import metadata from './meta/metadata';
import forms from './sections/forms';

const translations = {
    forms,
};

export const meta = {
    ...metadata,
};

export default translations;